module.exports = __webpack_public_path__ + "static/media/investment.c5bbeafa.svg";